import { Button } from "@tql/ui-components-react/tql/buttons";
import {
	fileCheck_01,
	plusCircleLine,
	upload_01,
} from "@tql/ui-components-react/untitled/icons";

import { useDeploymentType } from "~/shared/hooks/use-deployment-type.ts";

import * as styles from "../../index.module.css";

type RoutingGuideActionButtonsProps = {
	addNewLabel: string;
	onAddNew: () => void;
	onOpenSimulateModal: () => void;
};

export const RoutingGuideActionButtons = ({
	addNewLabel,
	onAddNew,
	onOpenSimulateModal,
}: RoutingGuideActionButtonsProps) => {
	const { isInternal } = useDeploymentType();
	if (!isInternal) {
		return null;
	}
	return (
		<div className={styles.addItemButtonContainer}>
			<Button
				id={"routing-button"}
				onClick={() => {}}
				svgIcon={fileCheck_01}
				variant={"primary"}
			>
				Change Log
			</Button>
			<Button
				id={"routing-button"}
				onClick={onOpenSimulateModal}
				svgIcon={fileCheck_01}
				variant={"primary"}
			>
				Simulate
			</Button>
			<Button
				id={"routing-button"}
				onClick={() => {}}
				svgIcon={upload_01}
				variant={"primary"}
			>
				Upload Excel
			</Button>
			<Button
				id={"routing-button"}
				onClick={onAddNew}
				svgIcon={plusCircleLine}
				variant={"primary"}
			>
				{addNewLabel}
			</Button>
		</div>
	);
};
